import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-amptalk-integration-error',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './amptalk-integration-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./amptalk-integration-error.component.scss'],
})
export class AmptalkIntegrationErrorComponent {
  constructor(
    private dialogRef: MatDialogRef<AmptalkIntegrationErrorComponent>,
  ) {}

  close(): void {
    this.dialogRef.close()
  }
}
